export default {
  usuario: {},
  usuarios: [],
  produtos: [],
  anuncios: []
};
